import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './app/fonts.css';
import './app/theme.css';
import { App } from './app/App.js';

const root = document.getElementById('root');
if (!root) throw new Error('нет контейнера #root');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
